import { dynamic } from '@unifyapps/carbon/external/dynamic';
import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/types/blockDefinition';
import type {
  BlockStateUnionType,
  BlockType,
  ComponentTypeUnionType,
} from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';

const importProgressComponent = () =>
  import(
    /* webpackChunkName: "progress-block" */
    './Progress'
  );

// adding loading: () => null such that nearest <Suspense /> is not triggered when the block is loading
const Progress = dynamic(importProgressComponent, { loading: () => null });

class ProgressBlockStateDefinition implements BlockStateDefinition {
  getBlockVersion() {
    return 0;
  }

  getComponent() {
    return Progress;
  }

  get type(): ComponentTypeUnionType {
    return 'ProgressBar';
  }

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component, ['content', 'appearance', 'componentType']),
      }) as BlockStateUnionType;
  }

  preload() {
    return {
      blockPreload: importProgressComponent,
    };
  }
}

export default ProgressBlockStateDefinition;
